// import one from '../assets/jpg/landingPage.jpg'
// import two from '../assets/svg/projects/two.svg'
// import three from '../assets/svg/projects/three.svg'
// import four from '../assets/svg/projects/four.svg'
// import five from '../assets/svg/projects/five.svg'
// import six from '../assets/svg/projects/six.svg'
// import seven from '../assets/svg/projects/seven.svg'
// import eight from '../assets/svg/projects/eight.svg'

import EduPulse from '../assets/jpg/mainpage.png'
import portfolio from '../assets/jpg/portfolio.png'
import invoice from '../assets/jpg/invoice.png'


export const projectsData = [

    {
        id: 1,
        projectName: 'ED-Tech-Platform',
        projectDesc: 'ED-Tech-Platform is an (Education Technology) web application developed using the MERN stack.',
        tags: ['RACT', 'Node', 'MONGODB', 'JSX', 'EXPRESS', 'MONGOOSE'],
        code: 'https://github.com/Aftab1999/EduPulse',
        demo: 'https://mosam-ind.netlify.app',
        image: EduPulse,
    },

    {
        id: 2,
        projectName: 'Saloon Web App',
        projectDesc: 'It is a web application to book Barber Shop.',
        tags: ['HTML', 'CSS', 'JavaScript', 'Reactjs', 'Redux'],
        code: 'https://github.com/Aftab1999/React_Full_Stack_Saloon_App.git',
        demo: 'https://aftabahmedansari.netlify.app',
        image: 'https://colorlib.com/wp/wp-content/uploads/sites/2/1_barbershop-websites.jpg'
    },
    {
        id: 3,
        projectName: 'Blog App',
        projectDesc: 'Created user-friendly blog app using React.js with dynamic features and customizable interface.',
        tags: ['RACT', 'Node', 'MONGODB', 'JSX', 'EXPRESS', 'MONGOOSE'],
        code: 'https://github.com/Aftab1999/Blog-Full-Stack-App',
        demo: 'https://aftabahmedansari.netlify.app',
        image: 'https://i.ytimg.com/vi/tlTdbc5byAs/maxresdefault.jpg'
    },
    {
        id: 4,
        projectName: 'Weather App',
        projectDesc: 'Weather forecast systems and applications predict weather conditions based on multiple parameters.',
        tags: ['Openweather API', 'JavaScript', 'HTML', 'CSS'],
        code: 'https://github.com/Aftab1999/Country-Wather-App',
        demo: 'https://aftabahmedansari.netlify.app',
        image: 'https://i.ibb.co/C9hZWVN/Weather-app.png'
    },
    {
        id: 4,
        projectName: 'React Portfolio',
        projectDesc: 'Developed a responsive portfolio website using React, Node, and JavaScript, featuring sections like "About Me," "Projects," and "Services".',
        tags: ['HTML', 'CSS', 'JavaScript', 'Reactjs', 'Material UI'],
        code: 'https://github.com/Aftab1999/React-Portfolio-',
        demo: 'https://aftabahmedansari.netlify.app',
        image: portfolio,
    },
    {
        id: 4,
        projectName: 'Invoice System',
        projectDesc: 'Developed an Invoice Management System web app with modules for Invoice, Customer, and Products.',
        tags: ['RACT', 'Node', 'MONGODB', 'JSX', 'EXPRESS', 'MONGOOSE'],
        code: 'https://github.com/Aftab1999/Invoice-management-system',
        demo: 'https://aftabahmedansari.netlify.app',
        image: invoice,
    },

]


